import * as React from "react";
const SvgFolder20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1 2h7.58l2 3.5H19V18H1V2Zm7.277 3.5L7.42 4H3v1.5h5.277ZM3 7.5V16h14V7.5H3Z",
      clipRule: "evenodd"
    })
  );
export default SvgFolder20Px;
